// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2TSPy","tab":"Tabs_tab__AOeIF","tabActive":"Tabs_tabActive__3nI9O"};